import { Model, modelRegistry } from './Model';
export class BeachZone extends Model {
    static entity = 'beach_zones';
    static primaryKey = 'id';
    id = null;
    name = null;
    description = null;
    photo_url = null;
    color = '#82b1ff';
    base_price = '0.00';
    seasonal_pricing = [];
    weekend_surcharge = '0.00';
    weekend_surcharge_type = 'fixed';
    sort_order = 0;
    created_at = null;
    updated_at = null;
    static fields() {
        return {
            id: this.attr(null),
            name: this.attr(null),
            description: this.attr(null),
            photo_url: this.attr(null),
            color: this.attr('#82b1ff'),
            base_price: this.attr('0.00', (value) => this.round(value, 2).toFixed(2)),
            seasonal_pricing: this.attr([]),
            weekend_surcharge: this.attr('0.00', (value) => this.round(value, 2).toFixed(2)),
            weekend_surcharge_type: this.attr('fixed'),
            sort_order: this.attr(0),
            created_at: this.attr(null),
            updated_at: this.attr(null),
        };
    }
    constructor(record) {
        super();
        this.$fill(record);
    }
    $duplicate() {
        return new BeachZone(this.$toJson());
    }
}
export default BeachZone;
modelRegistry.register('BeachZone', BeachZone);
//# sourceMappingURL=BeachZone.js.map